// Organizations service metadata + intro-gate helpers.
//
// Unlike infra services (OSS→Wasabi, WAAP→edge), Organizations is NOT a
// provisioned vendor service: every account intrinsically HAS an organization,
// so there is nothing to mint and no zone to seed. The `/services/organizations`
// landing is therefore a one-time intro — the console is always available. We
// remember that the intro has been seen in localStorage so the dashboard card
// drops straight into the console on subsequent visits.

/** Base path of the Organizations service console. Defined here (a dependency-free
 *  module) so the moved Teams/Projects pages can import it without a cycle back
 *  through OrganizationsConsole. */
export const ORG_BASE = '/services/organizations';

/** Route to the Organizations console (no per-service ID — it's account-scoped). */
export function orgConsoleRoute(): string {
  return `${ORG_BASE}/overview`;
}

/** Card metadata for the Organizations product (mirrors the catalog product). */
export const ORG_PRODUCT = {
  displayName: 'Organizations',
  description:
    'Projects, teams, contacts and administrators — organization management with fine-grained permissions.',
  features: ['Projects', 'Teams', 'Contacts', 'Permissions'],
} as const;

const ORG_INTRO_KEY = 'vn.org.intro.seen';

/** True once the user has opened the Organizations console at least once. */
export function orgIntroSeen(): boolean {
  try {
    return localStorage.getItem(ORG_INTRO_KEY) === '1';
  } catch {
    return false;
  }
}

/** Remember that the intro has been dismissed so future visits skip it. */
export function markOrgIntroSeen(): void {
  try {
    localStorage.setItem(ORG_INTRO_KEY, '1');
  } catch {
    /* localStorage unavailable (private mode) — fall back to always showing intro. */
  }
}
